export interface ContactTranslations {
  metaTitle: string;
  metaDesc: string;
  eyebrow: string;
  h1: string;
  lede: string;
  badge: string;
  infoTitle: string;
  infoLede: string;
  puneOffice: string;
  jaipurOffice: string;
  puneAddress: string;
  jaipurAddress: string;
  placeholderName: string;
  placeholderPhone: string;
  placeholderEmail: string;
  placeholderMessage: string;
  captchaLabel: string;
  placeholderCaptcha: string;
  btnSubmit: string;
  btnSending: string;
  successToast: string;
  errorToast: string;
  faqEyebrow: string;
  faqHeading: string;
  faqIntro: string;

  // Errors
  errNameRequired: string;
  errNameShort: string;
  errNameInvalid: string;
  errPhoneRequired: string;
  errPhoneInvalidChars: string;
  errPhoneShort: string;
  errPhoneLong: string;
  errPhoneIndian: string;
  errEmailRequired: string;
  errEmailInvalid: string;
  errMessageRequired: string;
  errMessageShort: string;
  errCaptchaRequired: string;
  errCaptchaIncorrect: string;

  faqs: { q: string; a: string }[];
}

export const getContactData = (locale: string): ContactTranslations => {
  if (locale === "hi") {
    return {
      metaTitle: "चिकित्सा से संपर्क करें - अस्पताल HIMS डेमो बुक करें",
      metaDesc: "अपने अस्पताल के लिए 30 मिनट का HIMS/HMIS डेमो बुक करने के लिए चिकित्सा से जुड़ें। एक कार्य दिवस के भीतर लिखित गो-लाइव योजना प्राप्त करें।",
      eyebrow: "संपर्क करें",
      h1: "हमसे जुड़ें। आइए आपके अस्पताल के एआई भविष्य का निर्माण करें।",
      lede: "हमारे एआई वर्कफ़्लो, परिनियोजन विकल्पों या ऑनबोर्डिंग के बारे में कोई प्रश्न है? हमारे नैदानिक उत्पाद विशेषज्ञ आपकी सहायता के लिए यहाँ हैं।",
      badge: "संपर्क फ़ॉर्म",
      infoTitle: "हमसे संपर्क करें",
      infoLede: "यदि आपका कोई प्रश्न है, तो आप फ़ॉर्म भरकर अपना प्रश्न भेज सकते हैं।",
      puneOffice: "पुणे कार्यालय:",
      jaipurOffice: "जयपुर कार्यालय:",
      puneAddress: "स्प्रिंट टॉवर, प्लॉट नंबर 9, हिंजेवाड़ी फेज 1 रोड, फेज 1, हिंजेवाड़ी राजीव गांधी इंफोटेक पार्क, हिंजेवाड़ी, पुणे, महाराष्ट्र 411057",
      jaipurAddress: "क्रीवेयर कोवर्क्स, बिजनेस पार्क, खाटू श्याम जी मंदिर के पास, इस्कॉन रोड, न्यू सांगानेर रोड, जयपुर, राजस्थान 302020",
      placeholderName: "पूरा नाम",
      placeholderPhone: "मोबाइल नंबर",
      placeholderEmail: "ईमेल आईडी",
      placeholderMessage: "अपना प्रश्न यहाँ लिखें",
      captchaLabel: "कैप्चा दर्ज करें",
      placeholderCaptcha: "कैप्चा दर्ज करें",
      btnSubmit: "जमा करें",
      btnSending: "भेज रहा है...",
      successToast: "पूछताछ सफलतापूर्वक सबमिट की गई",
      errorToast: "भेजने में विफल। कृपया पुन: प्रयास करें।",
      faqEyebrow: "ऑनबोर्डिंग और प्रश्न",
      faqHeading: "जब आप हमसे जुड़ते हैं तो क्या उम्मीद करें।",
      faqIntro: "डेमो, रोलआउट समयसीमा और आपके अस्पताल की विशिष्ट आवश्यकताओं के अनुरूप परिनियोजन विकल्पों पर उत्तर।",

      errNameRequired: "पूरा नाम आवश्यक है।",
      errNameShort: "नाम कम से कम 2 अक्षर का होना चाहिए।",
      errNameInvalid: "नाम में केवल अक्षर, रिक्त स्थान, एपोस्ट्रोफ और बिंदु हो सकते हैं।",
      errPhoneRequired: "मोबाइल नंबर आवश्यक है।",
      errPhoneInvalidChars: "मोबाइल नंबर में अमान्य वर्ण हैं।",
      errPhoneShort: "मोबाइल नंबर कम से कम 10 अंकों का होना चाहिए।",
      errPhoneLong: "मोबाइल नंबर बहुत लंबा है।",
      errPhoneIndian: "कृपया 6-9 से शुरू होने वाला एक वैध भारतीय मोबाइल नंबर दर्ज करें।",
      errEmailRequired: "ईमेल आईडी आवश्यक है।",
      errEmailInvalid: "कृपया एक वैध ईमेल पता दर्ज करें।",
      errMessageRequired: "क्वेरी संदेश आवश्यक है।",
      errMessageShort: "कृपया अपनी क्वेरी का वर्णन करते हुए थोड़ा लंबा संदेश लिखें।",
      errCaptchaRequired: "कैप्चा आवश्यक है।",
      errCaptchaIncorrect: "गलत कैप्चा परिणाम। कृपया पुन: प्रयास करें।",

      faqs: [
        {
          q: "डेमो कितने समय का है?",
          a: "30 मिनट। वॉकथ्रू एक नैदानिक उत्पाद विशेषज्ञ द्वारा चलाया जाता है जो इसे आपकी भूमिका - सीआईओ, चिकित्सा अधीक्षक, संचालन, वित्त या संस्थापक/सीईओ के अनुसार तैयार करता है।"
        },
        {
          q: "हमें डेमो में क्या लाना चाहिए?",
          a: "अपना सबसे कठिन वर्कफ़्लो लाएँ - फ्रंट-डेस्क कतार, दावों की अस्वीकृति, डिस्चार्ज की बाधा, ABDM तैयारी का अंतर - और हम इस पर Chikitsa का लाइव प्रदर्शन करेंगे।"
        },
        {
          q: "क्या हमें लिखित फॉलो-अप प्राप्त होगा?",
          a: "हाँ। प्रत्येक डेमो के बाद एक कार्य दिवस के भीतर लिखित गो-लाइव योजना - मॉड्यूल, एकीकरण, रोलआउट समयसीमा और मूल्य निर्धारण - भेजी जाती है।"
        },
        {
          q: "चिकित्सा कहाँ चलती है?",
          a: "हम भारत, अफ्रीका और मध्य पूर्व में परिनियोजन का समर्थन करते हैं - चिकित्सा क्लाउड पर, आपके अपने वीपीसी में, या पूरी तरह से ऑन-प्रिमाइसेस। प्रति परिनियोजन डेटा स्थानीयता विन्यास योग्य है।"
        }
      ]
    };
  }

  if (locale === "ar") {
    return {
      metaTitle: "اتصل بتشيكيتسا - احجز عرضاً تجريبياً لنظام HIMS",
      metaDesc: "تواصل مع تشيكيتسا لحجز عرض تجريبي مدته 30 دقيقة لنظام HIMS/HMIS المخصص لمستشفاك. احصل على خطة تشغيل مكتوبة في غضون يوم عمل واحد.",
      eyebrow: "اتصل بنا",
      h1: "تواصل معنا. لنبني مستقبل مستشفاك بالذكاء الاصطناعي.",
      lede: "هل لديك سؤال حول سير عمل الذكاء الاصطناعي لدينا، أو خيارات النشر، أو الإعداد؟ متخصصو المنتجات السريرية لدينا هنا لتقديم الإجابات التي تحتاجها.",
      badge: "نموذج الاتصال",
      infoTitle: "تواصل معنا",
      infoLede: "إذا كان لديك أي استفسار، يمكنك إرساله عن طريق ملء النموذج.",
      puneOffice: "مكتب بونا:",
      jaipurOffice: "مكتب جايبور:",
      puneAddress: "برج سبرينت، القطعة رقم 9، طريق هينجوادي المرحلة الأولى، بونا، ماهاراشترا 411057",
      jaipurAddress: "كريوير كوووركس، بيزنس بارك، قرب معبد خاتو شيام جي، طريق نيو سانجانير، جايبور، راجستان 302020",
      placeholderName: "الاسم الكامل",
      placeholderPhone: "رقم الهاتف المحمول",
      placeholderEmail: "البريد الإلكتروني",
      placeholderMessage: "اكتب استفسارك هنا",
      captchaLabel: "أدخل رمز التحقق (الـ Captcha)",
      placeholderCaptcha: "أدخل رمز التحقق",
      btnSubmit: "إرسال",
      btnSending: "جاري الإرسال...",
      successToast: "تم تقديم الاستفسار بنجاح",
      errorToast: "فشل الإرسال. يرجى المحاولة مرة أخرى.",
      faqEyebrow: "التهيئة والاستفسارات",
      faqHeading: "ماذا تتوقع عند الاتصال بنا.",
      faqIntro: "إجابات حول العروض التجريبية، والجداول الزمنية للتشغيل، وخيارات النشر المخصصة للاحتياجات المحددة لمستشفاك.",

      errNameRequired: "الاسم الكامل مطلوب.",
      errNameShort: "يجب أن يتكون الاسم من حرفين على الأقل.",
      errNameInvalid: "يمكن أن يحتوي الاسم على أحرف ومسافات وعلامات اقتباس ونقاط فقط.",
      errPhoneRequired: "رقم الهاتف المحمول مطلوب.",
      errPhoneInvalidChars: "رقم الهاتف المحمول يحتوي على أحرف غير صالحة.",
      errPhoneShort: "يجب أن يتكون رقم الهاتف من 10 أرقام على الأقل.",
      errPhoneLong: "رقم الهاتف المحمول طويل جداً.",
      errPhoneIndian: "يرجى إدخال رقم هاتف هندي صالح يبدأ بـ 6-9.",
      errEmailRequired: "البريد الإلكتروني مطلوب.",
      errEmailInvalid: "يرجى إدخال عنوان بريد إلكتروني صالح.",
      errMessageRequired: "رسالة الاستفسار مطلوبة.",
      errMessageShort: "يرجى كتابة رسالة أطول قليلاً تصف استفسارك.",
      errCaptchaRequired: "رمز التحقق مطلوب.",
      errCaptchaIncorrect: "رمز التحقق غير صحيح. يرجى المحاولة مرة أخرى.",

      faqs: [
        {
          q: "ما هي مدة العرض التجريبي؟",
          a: "30 دقيقة. يتم تشغيل العرض التوضيحي بواسطة أخصائي منتجات سريرية يقوم بتخصيصه وفقاً لدورك - مدير المعلومات، أو المدير الطبي، أو العمليات، أو المالية، أو المؤسس/الرئيس التنفيذي."
        },
        {
          q: "ماذا يجب أن نحضر للعرض التجريبي؟",
          a: "أحضر أصعب مسار عمل تواجهه - طوابير الاستقبال، أو رفض المطالبات، أو اختناقات الخروج، أو فجوة ABDM - وسنقوم بتشغيل تشيكيتسا لحلها مباشرة."
        },
        {
          q: "هل سنحصل على متابعة مكتوبة؟",
          a: "نعم. يتبع كل عرض تجريبي خطة تشغيل مكتوبة - الوحدات، والتكامل، والجدول الزمني للتشغيل والتسعير - في غضون يوم عمل واحد."
        },
        {
          q: "أين تعمل تشيكيتسا؟",
          a: "نحن ندعم عمليات النشر في الهند وأفريقيا والشرق الأوسط - على سحابة تشيكيتسا، أو في شبكة VPC الخاصة بك، أو بالكامل محلياً. موقع تخزين البيانات قابل للتخصيص لكل عملية نشر."
        }
      ]
    };
  }

  if (locale === "es") {
    return {
      metaTitle: "Contactar a Chikitsa - Reservar Demo de HIMS Hospitalario",
      metaDesc: "Conéctese con Chikitsa para reservar una demostración de HIMS/HMIS de 30 minutos adaptada a su hospital. Obtenga un plan de implementación por escrito dentro de un día hábil.",
      eyebrow: "Póngase en contacto",
      h1: "Conéctese con nosotros. Construyamos el futuro de IA de su hospital.",
      lede: "¿Tiene alguna pregunta sobre nuestros flujos de trabajo de IA, opciones de despliegue o integración? Nuestros especialistas clínicos de producto están aquí para brindarle las respuestas que necesita.",
      badge: "Formulario de Contacto",
      infoTitle: "Póngase en contacto",
      infoLede: "Si tiene alguna consulta, puede enviarla completando el formulario.",
      puneOffice: "Oficina de Pune:",
      jaipurOffice: "Oficina de Jaipur:",
      puneAddress: "Sprint Tower, Plot no. 9, Hinjawadi Phase 1 Rd, Phase 1, Hinjawadi Rajiv Gandhi Infotech Park, Hinjawadi, Pune, Maharashtra 411057",
      jaipurAddress: "Creware Coworks, Business Park, Cerca del templo Khatu Shyam ji, Isckon Road, New Sanganer Rd, Jaipur, Rajasthan 302020",
      placeholderName: "Nombre Completo",
      placeholderPhone: "Número de Teléfono",
      placeholderEmail: "Correo Electrónico",
      placeholderMessage: "Escriba su consulta aquí",
      captchaLabel: "Ingrese Captcha",
      placeholderCaptcha: "Ingrese Captcha",
      btnSubmit: "Enviar",
      btnSending: "Enviando...",
      successToast: "Consulta enviada con éxito",
      errorToast: "Error al enviar. Intente de nuevo.",
      faqEyebrow: "Integración y Consultas",
      faqHeading: "Qué esperar al conectarse con nosotros.",
      faqIntro: "Respuestas sobre demostraciones, plazos de lanzamiento y opciones de implementación adaptadas a las necesidades específicas de su hospital.",

      errNameRequired: "El nombre completo es requerido.",
      errNameShort: "El nombre debe tener al menos 2 caracteres.",
      errNameInvalid: "El nombre solo puede contener letras, espacios, apóstrofes y puntos.",
      errPhoneRequired: "El número de teléfono es requerido.",
      errPhoneInvalidChars: "El número de teléfono contiene caracteres no válidos.",
      errPhoneShort: "El teléfono debe tener al menos 10 dígitos.",
      errPhoneLong: "El número de teléfono es demasiado largo.",
      errPhoneIndian: "Ingrese un número móvil indio válido que comience con 6-9.",
      errEmailRequired: "El correo electrónico es requerido.",
      errEmailInvalid: "Ingrese una dirección de correo electrónico válida.",
      errMessageRequired: "El mensaje de consulta es requerido.",
      errMessageShort: "Escriba un mensaje un poco más largo describiendo su consulta.",
      errCaptchaRequired: "El captcha es requerido.",
      errCaptchaIncorrect: "Resultado de captcha incorrecto. Intente de nuevo.",

      faqs: [
        {
          q: "¿Cuánto dura la demostración?",
          a: "30 minutos. La guía es dirigida por un especialista clínico de producto que la adapta a su función: CIO, Director Médico, Operaciones, Finanzas o Fundador/CEO."
        },
        {
          q: "¿Qué debemos traer a la demostración?",
          a: "Traiga su flujo de trabajo más complejo (cola de recepción, rechazos de reclamaciones, cuellos de botella en altas, brecha de ABDM) y ejecutaremos Chikitsa en vivo frente a usted."
        },
        {
          q: "¿Recibiremos un seguimiento por escrito?",
          a: "Sí. Cada demostración va seguida de un plan de implementación por escrito (módulos, integraciones, plazos de implementación y precios) dentro de un día hábil."
        },
        {
          q: "¿Dónde se ejecuta Chikitsa?",
          a: "Admitimos implementaciones en India, África y Medio Oriente: en Chikitsa Cloud, en su propia VPC o completamente en las instalaciones. La residencia de datos es configurable por implementación."
        }
      ]
    };
  }

  if (locale === "fr") {
    return {
      metaTitle: "Contacter Chikitsa - Réserver Démo HIMS Hospitalier",
      metaDesc: "Connectez-vous avec Chikitsa pour réserver une démonstration HIMS/HMIS de 30 minutes adaptée à votre hôpital. Obtenez un plan de déploiement par écrit sous un jour ouvrable.",
      eyebrow: "Entrer en contact",
      h1: "Connectez-vous avec nous. Bâtissons l'avenir IA de votre hôpital.",
      lede: "Vous avez une question sur nos flux d'IA, nos options de déploiement ou l'intégration ? Nos spécialistes de produit clinique sont là pour vous fournir les réponses.",
      badge: "Formulaire de Contact",
      infoTitle: "Entrons en contact",
      infoLede: "Si vous avez une question, vous pouvez l'envoyer en remplissant le formulaire.",
      puneOffice: "Bureau de Pune :",
      jaipurOffice: "Bureau de Jaipur :",
      puneAddress: "Sprint Tower, Plot no. 9, Hinjawadi Phase 1 Rd, Phase 1, Hinjawadi Rajiv Gandhi Infotech Park, Hinjawadi, Pune, Maharashtra 411057",
      jaipurAddress: "Creware Coworks, Business Park, Près du temple Khatu Shyam ji, Isckon Road, New Sanganer Rd, Jaipur, Rajasthan 302020",
      placeholderName: "Nom Complet",
      placeholderPhone: "Numéro de Téléphone",
      placeholderEmail: "Adresse E-mail",
      placeholderMessage: "Saisissez votre message ici",
      captchaLabel: "Entrez le Captcha",
      placeholderCaptcha: "Entrez le Captcha",
      btnSubmit: "Envoyer",
      btnSending: "Envoi en cours...",
      successToast: "Demande envoyée avec succès",
      errorToast: "Échec de l'envoi. Veuillez réessayer.",
      faqEyebrow: "Intégration & Questions",
      faqHeading: "À quoi s'attendre en nous contactant.",
      faqIntro: "Réponses sur les démos, les délais de déploiement et les options d'installation adaptées aux besoins spécifiques de votre hôpital.",

      errNameRequired: "Le nom complet est obligatoire.",
      errNameShort: "Le nom doit comporter au moins 2 caractères.",
      errNameInvalid: "Le nom ne peut contenir que des lettres, des espaces, des apostrophes et des points.",
      errPhoneRequired: "Le numéro de téléphone est obligatoire.",
      errPhoneInvalidChars: "Le numéro de téléphone contient des caractères invalides.",
      errPhoneShort: "Le numéro de téléphone doit comporter au moins 10 chiffres.",
      errPhoneLong: "Le numéro de téléphone est trop long.",
      errPhoneIndian: "Veuillez entrer un numéro de téléphone mobile indien valide commençant par 6-9.",
      errEmailRequired: "L'e-mail est obligatoire.",
      errEmailInvalid: "Veuillez entrer une adresse e-mail valide.",
      errMessageRequired: "Le message de demande est obligatoire.",
      errMessageShort: "Veuillez écrire un message un peu plus long décrivant votre demande.",
      errCaptchaRequired: "Le captcha est obligatoire.",
      errCaptchaIncorrect: "Résultat captcha incorrect. Veuillez réessayer.",

      faqs: [
        {
          q: "Combien de temps dure la démo ?",
          a: "30 minutes. La présentation est animée par un spécialiste produit clinique qui l'adapte à votre rôle : DSI, Directeur Médical, Opérations, Finances ou Fondateur/PDG."
        },
        {
          q: "Que devons-nous apporter pour la démo ?",
          a: "Apportez votre flux de travail le plus complexe (file d'attente à l'accueil, rejets de réclamations d'assurance, goulot d'étranglement aux sorties, écart réglementaire ABDM) et nous ferons tourner Chikitsa en direct."
        },
        {
          q: "Recevrons-nous un suivi écrit ?",
          a: "Oui. Chaque démo est suivie d'un plan de déploiement écrit (modules, intégrations, délais de mise en œuvre et tarifs) sous un jour ouvrable."
        },
        {
          q: "Où s'exécute Chikitsa ?",
          a: "Nous prenons en charge les déploiements en Inde, en Afrique et au Moyen-Orient : sur le cloud Chikitsa, dans votre propre VPC ou entièrement sur site. La localisation des données est configurable par installation."
        }
      ]
    };
  }

  // Default / English mappings
  return {
    metaTitle: "Contact Chikitsa - Book a Hospital HIMS Demo",
    metaDesc: "Connect with Chikitsa to book a 30-minute HIMS/HMIS demo tailored for your hospital - CIO, Medical Superintendent, Finance or Operations. Get a written go-live plan within one business day.",
    eyebrow: "Get in Touch",
    h1: "Connect with us. Let’s build your hospital’s AI future.",
    lede: "Have a question about our AI workflows, deployment options, or onboarding? Our clinical product specialists are here to provide the answers you need.",
    badge: "Contact Form",
    infoTitle: "Let’s get in touch",
    infoLede: "If you are having any query, then you may send your query by filling the form",
    puneOffice: "Pune Office:",
    jaipurOffice: "Jaipur Office:",
    puneAddress: "Sprint Tower, Plot no. 9, Hinjawadi Phase 1 Rd, Phase 1, Hinjawadi Rajiv Gandhi Infotech Park, Hinjawadi, Pune, Hinjavadi, Maharashtra 411057",
    jaipurAddress: "Creware Coworks , Business Park, Near Khatu Shyam ji temple , Isckon Road, New, New Sanganer Rd, Jaipur, Rajasthan 302020",
    placeholderName: "Full Name",
    placeholderPhone: "Mobile Number",
    placeholderEmail: "Email ID",
    placeholderMessage: "Type your query here",
    captchaLabel: "Enter Captcha",
    placeholderCaptcha: "Enter Captcha",
    btnSubmit: "Submit",
    btnSending: "Sending...",
    successToast: "Inquiry submitted successfully",
    errorToast: "Failed to send. Please try again.",
    faqEyebrow: "Onboarding & Queries",
    faqHeading: "What to expect when you connect with us.",
    faqIntro: "Answers on demos, rollout timelines, and deployment options tailored for your hospital's specific needs.",

    errNameRequired: "Full Name is required.",
    errNameShort: "Name must be at least 2 characters long.",
    errNameInvalid: "Name can only contain letters, spaces, apostrophes, and dots.",
    errPhoneRequired: "Mobile number is required.",
    errPhoneInvalidChars: "Mobile number contains invalid characters.",
    errPhoneShort: "Mobile number must be at least 10 digits.",
    errPhoneLong: "Mobile number is too long.",
    errPhoneIndian: "Please enter a valid Indian mobile number starting with 6-9.",
    errEmailRequired: "Email ID is required.",
    errEmailInvalid: "Please enter a valid email address.",
    errMessageRequired: "Query message is required.",
    errMessageShort: "Please write a slightly longer message describing your query.",
    errCaptchaRequired: "Captcha is required.",
    errCaptchaIncorrect: "Incorrect captcha result. Please try again.",

    faqs: [
      {
        q: "How long is the demo?",
        a: "30 minutes. The walkthrough is run by a clinical product specialist who tailors it to your role - CIO, Medical Superintendent, Operations, Finance or Founder/CEO."
      },
      {
        q: "What should we bring to the demo?",
        a: "Bring your toughest workflow - front-desk queue, claim rejections, discharge bottleneck, ABDM readiness gap - and we'll run Chikitsa against it live."
      },
      {
        q: "Will we receive a written follow-up?",
        a: "Yes. Every demo is followed by a written go-live plan - modules, integrations, rollout timeline and pricing - within one business day."
      },
      {
        q: "Where does Chikitsa run?",
        a: "We support deployments in India, Africa and the Middle East - on Chikitsa Cloud, in your own VPC, or fully on-prem. Data residency is configurable per deployment."
      }
    ]
  };
};
